(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('StatoODGDialogController', StatoODGDialogController);

    StatoODGDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'StatoODG'];

    function StatoODGDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, StatoODG) {
        var vm = this;

        vm.statoODG = entity;
        vm.clear = clear;
        vm.dateformat = "dd/MM/yyyy HH:mm";
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.statoODG.id !== null) {
                StatoODG.update(vm.statoODG, onSaveSuccess, onSaveError);
            } else {
                StatoODG.save(vm.statoODG, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gestioneAttiApp:statoODGUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataOraCambioStato = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
